import { LinkPlugin } from '@platejs/link/react';
import { LinkElement } from 'components/plate-ui/link-element';
import { LinkFloatingToolbar } from 'components/plate-ui/link-floating-toolbar';

export const LinkKit = [
  LinkPlugin.configure({
    options: { forceSubmit: true },
    render: {
      node: LinkElement,
      afterEditable: () => <LinkFloatingToolbar />,
    },
  }),
];
